// extracted by mini-css-extract-plugin
export default {"container":"oNHadvdohs8lYA6uzUw3","content":"grXPzTTD0d7hi7lUnBoE","message":"GXK3m1hkd9rZgBoh9zh9","cta":"Eokc9pANg_BRGwSR4EWp"};